/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n'
import { applyFilters, addFilter } from '@wordpress/hooks'
import { compose } from '@wordpress/compose'
import { Fragment } from '@wordpress/element'
import { i18n } from 'cartzillagb'
import {
    PanelBody, ToggleControl 
} from '@wordpress/components'
import {
    RichText
} from '@wordpress/block-editor'

/**
 * Internal dependencies
 */
import { name } from './index'

/**
 * External dependencies
 */
import {
    ButtonControlsHelper, ButtonEditHelper
} from '~cartzillagb/components'
import { withTabbedInspector, withClickOpenInspector } from '~cartzillagb/higher-order'
import classnames from 'classnames'

addFilter( 'cartzillagb.button.edit.inspector.style.before', 'czgb/button', ( output, props ) => {
    const { 
        setAttributes,  
    } = props

    return (
        <Fragment>
            <PanelBody title={ __( 'Button Settings', i18n ) }initialOpen={ false } >
                <ButtonControlsHelper
                    attrNameTemplate="button1%s"
                    setAttributes={ setAttributes }
                    blockAttributes={ props.attributes }
                />
                console.log(blockAttributes)
            </PanelBody>
        </Fragment>
    )
} )

const edit = props => {
    const { 
        attributes, 
        setAttributes, 
        className
    } = props 

    const mainClasses = classnames( [
        className,
    ], applyFilters( `cartzillagb.${ name.replace( 'czgb/', '' ) }.main-block.classes`, {}, props ) )


    return (
        <div className={ mainClasses }>
            <ButtonEditHelper
                attrNameTemplate={ `button1%s` }
                setAttributes={ setAttributes }
                blockAttributes={ props.attributes }
            />
            
        </div>
    )
}



export default compose(
    withTabbedInspector( [ 'style', 'advanced' ] ),
    withClickOpenInspector( [
        [ '.czgb-button', 'button' ],
    ] )
)( edit )